import { isSimpleError, isSimpleErrors, SimpleError, SimpleErrors } from '@simonbackx/simple-errors';

import { ViewportHelper } from '../ViewportHelper';
import { GlobalEventBus } from '../EventBus';
/***
 * Distributes errors to components that ask for it. The first that asks receives
 */
export class ErrorBox {
    /// Remaining errors to distribute
    errors: SimpleErrors;
    originalErrors: SimpleErrors;

    static scrollToElements: [any[], HTMLElement][] = [];
    static scrollTimer?: number;

    constructor(errors: unknown) {
        if (isSimpleError(errors)) {
            this.errors = new SimpleErrors(errors);
        } else if (isSimpleErrors(errors)) {
            this.errors = errors;
        } else {
            this.errors = new SimpleErrors(new SimpleError({
                code: 'unknown_error',
                message: (errors as Error).message,
            }));
        }
        this.originalErrors = new SimpleErrors(...this.errors.errors);
    }

    hasCode(code: string) {
        return this.originalErrors.hasCode(code);
    }

    /// Register a handler for field.
    /// Returns a reference to SimpleErrors that will get adjusted when arrays are distrubuted (this is not yet implemented)
    forFields(fields: string[]): SimpleErrors {
        const errors = new SimpleErrors();

        for (let index = this.errors.errors.length - 1; index >= 0; index--) {
            const error = this.errors.errors[index];
            if (error.doesMatchFields(fields)) {
                errors.unshiftError(error);
                this.errors.removeErrorAt(index);
            }
        }

        return errors;
    }

    get remaining(): SimpleErrors {
        // note that this is a reference! So the errors can still change
        return this.errors;
    }

    static scrollIntoView(element: HTMLElement) {
        ViewportHelper.scrollIntoView(element, 'center', true);
    }

    private static fireScroll() {
        // Take the highest element
        let minimum: number | undefined;
        let firstElement: HTMLElement | undefined;

        for (const [arr, element] of this.scrollToElements) {
            if (arr.length === 0) {
                continue;
            }
            if (!document.body.contains(element)) {
                // Went out of dom before the timer fired
                continue;
            }
            const pos = element.getBoundingClientRect().top;
            if (minimum === undefined || pos < minimum) {
                minimum = pos;
                firstElement = element;
            }
        }

        if (firstElement) {
            this.scrollIntoView(firstElement);
        }
        this.scrollToElements = [];
        this.scrollTimer = undefined;
    }

    /// Scroll to an element, errorBox will decide which one if it is called multiple times
    // You need to provide the array of errors because it is possible to change the errors after this call
    // So we need to detect if the errors are empty or not
    static scrollTo(errors: any[], el: HTMLElement) {
        this.scrollToElements.push([errors, el]);

        if (!this.scrollTimer) {
            this.scrollTimer = window.setTimeout(this.fireScroll.bind(this), 250);
        }
    }

    static _didSignal = false;

    static readonly updateEvent = Symbol();

    /**
     * Notifies listeners of a change in displayed errors
     */
    static sendUpdateEventIfNeeded() {
        if (this._didSignal) {
            return;
        }
        this._didSignal = true;

        window.setTimeout(() => {
            this._didSignal = false;
            GlobalEventBus.sendEvent(this.updateEvent, undefined).catch(console.error);
        }, 150);
    }
}
